// extracted by mini-css-extract-plugin
export var deleteIcon = "_s7-5";
export var deleteOption = "_s7-3";
export var divider = "_s7-2";
export var downloadIcon = "_s7-4";
export var drawer = "_s7-0";
export var drawerFooter = "_s7-6";
export var drawerOpen = "_s7-1";
export var highlighted = "_s7-7";
export var lighterHighlight = "_s7-8";